
import React, { useState } from 'react'
import { EyeIcon, SearchIcon } from '@heroicons/react/solid';
import { DocumentDownloadIcon } from "@heroicons/react/outline";
import Layout from "../../components/Layout/Layout";
import { Link } from 'react-router-dom';
import CustomerServices from '../../services/CustomerServices';
import { useEffect } from 'react';
import { convert, formatDate } from '../../utils/convertDate';
import Paginate from '../../utils/Paginate';
import { BudgetServices } from '../../services/BudgetServices';
import DatePicker from 'react-date-picker';
import { FormatMoney } from '../../utils/formatMoney';


const statusStyles = {
  Within_Range: 'bg-green-500 text-white',
  Expired: 'bg-amber-400 text-white',
  Exceeded: 'bg-orange-600 text-white',

}

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Budget() {

  const [customer, setCustomer] = useState([])
  const [search, setSearch] = useState("")
  const [pageIndex, setPageIndex] = useState(1);
  const [prevPage, setPrev] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPage, setPage] = useState(0)
  const [nextPage, setNextPage] = useState(false);
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const oldFrom = new Date().setDate(new Date().getDate() - 7);
  const [formValues, setFormValues] = useState({
    from: new Date(oldFrom),
    to: new Date()
  })
  const defaultTo = formatDate(new Date());
  const longNew = formatDate(defaultTo);
  const [too, setToo] = useState(convert(longNew));
  const defaultFrom = formatDate(new Date().setDate(new Date().getDate() - 7))
  const longDate = formatDate(defaultFrom);
  const [fromm, setFromm] = useState(convert(longDate));
  const [pageLength, setPageLength] = useState("");
  const [budgetMnth, setBudgetMonth] = useState("");
  const [budgetStatus, setBudgetStatus] = useState("")


  const listCustomer = async () => {
    const customers = await BudgetServices.listBudget(pageIndex, 10, search, fromm, too, budgetMnth, budgetStatus);
    setCustomer([...customers.data.result]);
    setPageLength([...customers.data.result].length);
    setPageNumber(customers.data.totalCount)
    setPageIndex(customers.data.pageIndex)
    setPrev(customers.data.hasPreviousPage);
    setPage(customers.data.totalPages)
    setNextPage(customers.data.hasNextPage)
  }

  const searchCustomer = async (text) => {
     setSearch(text);
  };
  const dateValidation = {
    fromHandler: (event) => {
      setFormValues({ ...formValues, from: event })
    },
    toHandler: (event) => {
      setFormValues({ ...formValues, to: event })
    }
  };
  const range = async (e) => {
    e.preventDefault();
    const newDate = formatDate(formValues.from)
    setFrom(formValues.from)
    var longDate = formatDate(newDate);
    setFromm(convert(longDate));

    const toDate = formatDate(formValues.to);
    setTo(formValues.to)
    setToo(convert(toDate));

    const resp = await BudgetServices.listBudget(pageIndex, 10, search, convert(newDate), convert(toDate), budgetMnth, budgetStatus);
    setCustomer([...resp.data.result]);
    setPageLength([...resp.data.result].length);
    setPageNumber(resp.data.totalCount);
    setPageIndex(resp.data.pageIndex);
    setPrev(resp.data.hasPreviousPage);
    setPage(resp.data.totalPages);
    setNextPage(resp.data.hasNextPage);

  }
  const setSort = async (month) => {
    month = month === "All" ? "" : month;
      setBudgetMonth(month);
      const customers = await BudgetServices.listBudget(pageIndex, 10, search, fromm, too, month, budgetStatus);
      setCustomer([...customers.data.result]);
      setPageLength([...customers.data.result].length);
      setPageNumber(customers.data.totalCount)
      setPageIndex(customers.data.pageIndex)
      setPrev(customers.data.hasPreviousPage);
      setPage(customers.data.totalPages)
      setNextPage(customers.data.hasNextPage)

  }
  const setStatus = async (stat) => {
     stat = stat === "All" ? "" : stat;
      setBudgetStatus(stat);
      const customers = await BudgetServices.listBudget(pageIndex, 10, search, fromm, too, budgetMnth, stat);
      setCustomer([...customers.data.result]);
      setPageLength([...customers.data.result].length);
      setPageNumber(customers.data.totalCount)
      setPageIndex(customers.data.pageIndex)
      setPrev(customers.data.hasPreviousPage);
      setPage(customers.data.totalPages)
      setNextPage(customers.data.hasNextPage)
    

  }
  useEffect(() => {
    listCustomer();
  }, [pageIndex])

  return (<>
    <Layout title="Budget" pageTag={'budget'} current={'/budgets'} curentPage={'list-budget'}  >
      <React.Fragment>
        <main>
          <div className='max-w-7xl '>
            <div className="">
              <div className="sm:flex sm:items-center">
                <div className="sm:flex-auto flex">
                
                  <div className=" relative rounded-md shadow-sm ml-3">
                    <p className='text-sm leading-3 text-gray-500'>From</p>
                    <div>
                      <DatePicker onChange={dateValidation.fromHandler} value={formValues.from} />
                    </div>
                  </div>
                  <div className=" relative rounded-md shadow-sm ml-3">
                    <p className='text-sm leading-3 text-gray-500'>To</p>
                    <div>
                      <DatePicker onChange={dateValidation.toHandler} value={formValues.to} />
                    </div>
                  </div>
                  <div className="mt-5 ml-3 relative rounded-md shadow-sm">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                    </div>
                    <input
                      type="text"
                      name="user"
                      id="user"
                      onChange={(e) =>
                        searchCustomer(e.target.value)
                      }
                      className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                      placeholder="Search budget"
                    />
                  </div>
                  <div className='mt-5 ml-4'>
                    <button
                      onClick={range}
                      className='hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-6 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto'>Search</button>
                  </div>
                  <div className="mt-5 relative rounded-md shadow-sm ml-3">
                    <select
                      id="currency"
                      name="currency"
                      onChange={(e) => setSort(e.target.value)}
                      placeholder="Sort by"
                      className="focus:ring-indigo-500 focus:border-indigo-500 h-full py-0 pl-2 pr-7 border-gray-300 bg-transparent text-gray-500 sm:text-sm rounded-md"
                    >
                      <option value="All">Sort by month</option>
                      <option value="All">All</option>
                      <option value="January">January</option>
                      <option value="February">February</option>
                      <option value="March">March</option>
                      <option value="April">April</option>
                      <option value="May">May</option>
                      <option value="June">June</option>
                      <option value="July">July</option>
                      <option value="August">August</option>
                      <option value="September">September</option>
                      <option value="October">October</option>
                      <option value="November">November</option>
                      <option value="December">December </option>
                    </select>
                  </div>
                  <div className="mt-5 relative rounded-md shadow-sm ml-3">
                    <select
                      id="currency"
                      name="currency"
                      onChange={(e) => setStatus(e.target.value)}
                      placeholder="Sort by"
                      className="focus:ring-indigo-500 focus:border-indigo-500 h-full py-0 pl-2 pr-7 border-gray-300 bg-transparent text-gray-500 sm:text-sm rounded-md"
                    >
                      <option>Filter by</option>
                      <option value="All">All</option>
                      <option value="Exceeded">Exceeded</option>
                      <option value="Within_Range">Within Range</option>
                      <option value="Expired ">Expired </option>
                    </select>
                  </div>
                </div>
              </div>
              {customer.length === 0 ? (
                <div className=" mt-8"> No data available for these dates to show. </div>
              ) :  <>
              <div className="mt-8 flex flex-col">
                <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                  <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                    <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg">

                      <table className="min-w-full table-fixed divide-y divide-gray-300">
                        <thead>
                          <tr>
                            <th scope="col" className="min-w-[8rem] pl-4 py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900">
                              Customer's Name
                            </th>
                            <th scope="col" className="min-w-[10rem] py-3.5 px-3 italic font-normal text-left text-sm  text-gray-900">
                              BVN
                            </th>
                            <th scope="col" className="min-w-[10rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                              Customer's Account Number
                            </th>
                            
                            <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                              Date Budget Set
                            </th>
                            <th scope="col" className="min-w-[8rem] px-1 py-3.5 text-left text-sm italic font-normal text-gray-900">
                              Budget Amount
                            </th>
                            <th scope="col" className="min-w-[8rem] px-1 py-3.5 text-left text-sm italic font-normal text-gray-900">
                              Budget Month
                            </th>
                            <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                              Un-utilized Amount
                            </th>
                            <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                              Utilized Amount
                            </th>
                            <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                              Status
                            </th>
                            <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">

                            </th>
                            <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                              <span className="sr-only">Edit</span>
                            </th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200 bg-white">
                          {customer.map((person, i) => (
                            <tr key={i} className="bg-gray-50">
                              <td className="whitespace-nowrap pl-4 pl-4 py-4 pr-3 text-sm font-medium text-indigo-600">{person.fullName}</td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{person.bvn} </td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{person.accountNumber}</td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500"> {convert(person.dateCreated)}</td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{FormatMoney(person.budgetAmount)}</td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{person.budgetMonth}</td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{FormatMoney(person.budgetBalance)}</td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{FormatMoney(person.amountSpent)}</td>
                              <td><span className={classNames(
                                statusStyles[person.status], "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium text-gray-900")}>{person.status}</span></td>

                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <Paginate
                                    nextPage={nextPage}
                                    pageIndex={pageIndex}
                                    totalCount={pageNumber}
                                    totalPages={totalPage}
                                    prevPage={prevPage}
                                    setPageIndex={setPageIndex}
                                />
            </>}
             

            </div>

          </div>
        </main>

      </React.Fragment>

    </Layout>




  </>);
}